import Button from '@material-ui/core/Button';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const DialPadComponent = lib.styled.div`
  background-color: ${colors.white};
  height: 250px;
  max-height: 250px;
  padding-top: 10;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  justify-content: space-evenly;
  margin-bottom: 15px;

  .center-numbers{
    text-align: center;
  }
`;
export const ButtonComponent = lib.styled(Button)`
  border-radius: 20px!important;
  &:hover { background-color: ${colors.lightGray07}!important;}
  span {
    display: flex;
    flex-direction: column;
    width: 59px;
    height: 54px;

    span:first-child {
      font-size: 30px;
      height: 40px!important;
      font-weight: 300;
    }
    span:last-child {
      font-size: 14px;
      opacity: 0.6;
      text-transform: lowercase!important;
      height: 20px!important;
    }

    .plus {
      font-size: 13px!important;
      line-height: 10px!important;
    }
  }
`;
